/**
 * External Dependencies
 */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Col,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from 'reactstrap';

/**
 * Internal Dependencies
 */
import Icon from '../icon';
/* import Carousel from './carousel'; */

/**
 * Component
 */
class ModalButtons extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: true,
      bottoni: [],
      selectedButtons: [],
      searched: [],
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.dismiss();
    this.setState({
      modalOpen: false,
    });
  }

  dismiss() {
    this.props.unmountMe();
  }

  loadBottoni() {
    window.api.totem.bottoni
      .elenco()
      .then(async res => {
        const bottoni = res.data.bottoni;

        const selectedButtons = [];
        if (this.props.buttons) {
          for (let b of this.props.buttons) {
            selectedButtons.push(b.id);
          }
        }

        this.setState({
          selectedButtons: selectedButtons,
          bottoni: bottoni,
          searched: bottoni,
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  change(e) {
    let filter = e.target.value.toLowerCase();
    let searched = [];
    if (filter === '') {
      searched = this.state.bottoni;
    } else {
      this.state.bottoni.map(bottone => {
        if (bottone.content.toLowerCase().includes(filter)) {
          searched.push(bottone);
        }
      });
    }
    this.setState({
      searched: searched,
    });
  }

  salvaBottoni() {
    let buttons = [];
    this.state.selectedButtons.map(b => {
      let bot = this.state.bottoni.find(o => o.id === b);
      if (bot.tipo == 'pagina') {
        let botP = this.props.buttons?.find(o => o.id == b);
        if (botP) {
          bot.pagina = botP.pagina;
        }
      }
      buttons.push(bot);
    });
    this.props.setButtons(buttons);
    this.dismiss();
  }

  componentDidMount() {
    this.loadBottoni();
  }

  handleButtonClick(button) {
    let selectedButtons = this.state.selectedButtons;
    if (selectedButtons.includes(button.id)) {
      selectedButtons.splice(selectedButtons.indexOf(button.id), 1);
    } else {
      selectedButtons.push(button.id);
    }

    this.setState({
      selectedButtons: selectedButtons,
    });
  }

  render() {
    const { searched, selectedButtons } = this.state;

    return (
      <Fragment>
        <Modal
          isOpen={this.state.modalOpen}
          toggle={this.toggle}
          fade
          backdrop="static"
          size="lg"
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title h2">Bottoni</h5>
            <Button className="close" color="" onClick={this.toggle}>
              <Icon name="x" />
            </Button>
          </div>

          <div style={{ padding: '15px' }}>
            <Input
              type="text"
              placeholder="Cerca..."
              onChange={e => this.change(e)}
            />
          </div>

          <ModalBody
            style={{
              flex: 1,
              overflowY: 'auto',
              overflowX: 'hidden',
              maxHeight: '60vh',
              padding: '15px',
            }}
          >
            <Row>
              {searched.map(b => {
                return (
                  <Col lg="4" key={b.id}>
                    {selectedButtons.indexOf(b.id) > -1 ? (
                      <span className="check-badge">✔</span>
                    ) : (
                      <></>
                    )}
                    <Button
                      size="lg"
                      color={b.tipo == 'pagina' ? 'success' : 'brand'}
                      onClick={() => this.handleButtonClick(b)}
                      className={
                        selectedButtons.indexOf(b.id) > -1 ? 'btn-media' : ''
                      }
                      style={{
                        width: '100%',
                        height: '100px',
                        marginBottom: '25px',
                        display: 'block',
                        position: 'relative',
                        wordWrap: 'break-word',
                        whiteSpace: 'normal',
                        textAlign: 'center',
                        padding: '12px',
                        fontSize: '1rem',
                        lineHeight: '1.3',
                        overflow: 'hidden',
                      }}
                    >
                      <div
                        style={{
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                        }}
                      >
                        {b.content}
                      </div>
                      <span
                        style={{
                          fontSize: '0.65em',
                          position: 'absolute',
                          bottom: '3px',
                          right: '6px',
                        }}
                      >
                        {b.tipo == 'informativo'
                          ? 'INFO'
                          : b.tipo == 'coda con ritardo'
                            ? 'CODA RIT'
                            : b.tipo}
                      </span>
                    </Button>
                  </Col>
                );
              })}
            </Row>
          </ModalBody>

          <ModalFooter
            style={{
              flexShrink: 0,
              backgroundColor: 'white',
              borderTop: '1px solid #dee2e6',
              padding: '15px',
            }}
          >
            <Button color="secondary" onClick={this.toggle}>
              Annulla
            </Button>{' '}
            <Button
              form="form"
              color="brand"
              onClick={() => this.salvaBottoni()}
            >
              Salva
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

export default connect(({ settings }) => ({
  settings,
}))(ModalButtons);
